import classNames from 'classnames';
import { MCheckbox } from '@Components/Base';
import { Tag } from 'antd';

import styles from './card.module.css';

interface CardProps {
  vendorName: string;
  rate: number;
  amount: number | string;
  available: boolean;
  brand: string;
  isBest: boolean;
  handleShowVendorDetails: () => void;
}

const Card = ({
  vendorName,
  amount,
  available,
  brand,
  rate,
  isBest = false,
  handleShowVendorDetails,
}: CardProps): JSX.Element | null => {
  return (
    <div className={styles.card}>
      <div className={styles.cardManageSection}>
        <div className={styles.cardType}>
          <div className={styles.cardCaption} onClick={handleShowVendorDetails}>
            {vendorName}
          </div>
        </div>
        {isBest && (
          <Tag color="#71D1A4" className={styles.cheapest}>
            Cheapest
          </Tag>
        )}
        <MCheckbox onClick={() => null} />
      </div>
      <div
        className={classNames(styles.cardInfoSection, isBest && styles.best)}
      >
        <div className={styles.cardInfoType}>
          <span>Rate</span>
          <span>{rate}</span>
        </div>
        <div className={styles.cardInfoType}>
          <span>Amount</span>
          <span>{amount}</span>
        </div>
        <div className={styles.cardInfoType}>
          <span>Available</span>
          <span>{available ? 'Yes' : 'No'}</span>
        </div>
        <div className={styles.cardInfoType}>
          <span>Brand</span>
          <span>{brand}</span>
        </div>
      </div>
    </div>
  );
};

export default Card;
